import React, { useEffect } from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { itx } from "../translationItx/itx";
import { isUiModeDeveloper } from "../uiMode";

export default function DialogHost(props: { style?: any }) {
  var { style } = props;
  useOnChangeWatcher(state?.dialogManager);

  if (!state) {
    return <div>{itx("dialogHost.noStateAvailible", "No State availible yet")}</div>;
  }

  if (!state.dialogManager.isOpen) {
    return <div style={{ display: "none" }} className="dialogWrapper"></div>;
  }

  let cls = state.dialogManager.isModal ? "dialogWrapper" : "nonModalDialogWrapper";

  if (!state.dialogManager.isModal) {
    if (!style) {
      style = {};
    }
    style.left = "0px"; // no itx
    style.top = "0px"; // no itx
  }

  if (!isUiModeDeveloper()) {
    style = {
      ...style,
      userSelect: "none",
    };
  }

  if (style && !state.dialogManager.isModal && !state.dialogManager.closeOnClickOutside) {
    style.pointerEvents = "none";
  }

  return (
    <div
      id="dialogWrapper"
      className={cls + " App"} // no itx
      style={style}
      onMouseDown={(event: any) => {
        if (state.dialogManager.closeOnClickOutside) {
          if (event.target.id === "dialogWrapper") {
            event.stopPropagation();
            state.dialogManager.closeDialog(false);
          }
        }
      }}
    >
      {state.dialogManager.dialogStack.map(entry => <React.Fragment key={entry.key}>{entry.dialog}</React.Fragment>)}
    </div>
  );
}
